import React, {useEffect, useState} from 'react';
import './TISComponent.css';
import axios from "axios";
import Pryamie3_2 from "../../static/img/TIS/Direct/3_2_Pryamie.svg";
import LeftElement01 from "../../static/img/TIS/Money.svg";
import LeftElement02 from "../../static/img/TIS/Two users.svg";
import LeftElement03 from "../../static/img/TIS/User.svg";
import TISComponentClock from "../../static/img/TIS/Clock.svg";
import TISDownloads from "../../static/img/TIS/download.gif";
import ChangeLink from "../../Elements/ChangeLink/ChangeLink";


function  TISComponent(props){
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    // console.log('updateLastInvestments',props.PrerenderTexts);
    const [counters, setCounters] = useState('');
    const [updateLastInvestmentsState, setupdateLastInvestmentsState] = useState('');
    const [now, setnow] = useState(0);

    function updateLastInvestments() {
        let now = new Date();
        setnow(now)
        axios
            .get('https://my.profiforex.com/api/ajax/tis/counters', {withCredentials: true})
            .then((userData) => {
                    // console.log('counters', userData.data);
                    if (userData.data) {
                        setCounters(userData.data);
                    }
                }
            )
            .catch(e => console.log(e));

        axios
            .get('https://my.profiforex.com/api/ajax/tis/last-investments', {withCredentials: true})
            .then((userData) => {
                    // console.log('last-investments', userData.data);
                    if (userData.data) {
                        setupdateLastInvestmentsState(userData.data);
                    }
                }

            )
            .catch(e => console.log(e));
    }

    useEffect(() => {
        updateLastInvestments()
        const intervalId = setInterval(updateLastInvestments, 70000);
        return () => clearInterval(intervalId);
    },[]);

     return (
            <div className="TISComponent">
                <div className="TISComponentTop">
                    <div className="TISComponentTopText">
                        <div className="TISComponentTopText01">
                            <TextSource ArrIndex= 'TISComponent0000'>Инвестирование в трейдеров</TextSource>
                        </div>
                        <div className="TISComponentTopText02">
                            <TextSource ArrIndex= 'TISComponent0005'>Мы представляем уникальный выгодный способ вложения средств с большими процентами</TextSource>
                        </div>
                    </div>
                    <div className="TISComponentTopButton">
                        <ChangeLink  lang = {props.lang} to='/invest/monitoring'><div  className='TisButtonGreen'>
                            <div  className='TisButtonGreenImg'><img alt='alt' src={Pryamie3_2} width={'20px'}/></div>
                            <div  className='TisButtonGreenText'><TextSource ArrIndex= 'TISComponent0010'>Выбрать трейдера</TextSource></div>
                        </div></ChangeLink>
                    </div>
                </div>
                <div className="TISComponentDown">
                    <div className="TISComponentDownLeft">
                        <div className="TISComponentDownLeftElement">
                            <div className="TISComponentDownLeftElementTop">
                                <TextSource ArrIndex= 'TISComponent0015'>Проинвестировано</TextSource>
                            </div>
                            <div className="TISComponentDownLeftElementBottom">
                                <img alt='alt' src={LeftElement01} width={'20px'}/> {counters.AmountInvestment}
                            </div>
                        </div>
                        <div className="TISComponentDownLeftElementBorder"/>
                        <div className="TISComponentDownLeftElement">
                            <div className="TISComponentDownLeftElementTop">
                                <TextSource ArrIndex= 'TISComponent0020'>Трейдеров</TextSource>
                            </div>
                            <div className="TISComponentDownLeftElementBottom">
                                <img alt='alt' src={LeftElement02} width={'23px'}/> {counters.CountTraders}
                            </div>
                        </div>
                        <div className="TISComponentDownLeftElementBorder"/>
                        <div className="TISComponentDownLeftElement">
                            <div className="TISComponentDownLeftElementTop">
                                <TextSource ArrIndex= 'TISComponent0025'>Инвесторов</TextSource>
                            </div>
                            <div className="TISComponentDownLeftElementBottom">
                                <img alt='alt' src={LeftElement03} width={'14px'}/>{counters.CountInvestors + counters.CountCopyTrading}
                            </div>
                        </div>
                        <div className="TISComponentDownLeftElementBorder"/>
                    </div>
                        {now && updateLastInvestmentsState[0] ? <div className="TISComponentDownRight">
                            <div className="TISComponentDownRightElement">
                                <div className="TISComponentDownRightElementLeft"><img alt='alt' src={TISComponentClock} width={'16px'}/>
                                <div className="TISComponentDownRightElementText01">{Math.trunc(now.getTime()/1000 - updateLastInvestmentsState[0].Date)} <TextSource ArrIndex= 'TISComponent0030'>секунды назад</TextSource></div></div>
                                <div className="TISComponentDownRightElementText02">{(props.PrerenderTexts ? JSON.parse(props.PrerenderTexts['TISComponent0035'])[props.lang] : '*проинвестировали') + ' ' + updateLastInvestmentsState[0].Amount + '$ ' + (props.PrerenderTexts ? JSON.parse(props.PrerenderTexts['TISComponent0040'])[props.lang] : '*в')+ ' '} <ChangeLink  lang = {props.lang} to='/invest/monitoring'>{updateLastInvestmentsState[0].NickName}</ChangeLink></div>
                                <div className="TISComponentDownRightElementText03"> </div>
                            </div>
                            <div className="TISComponentDownRightElement">
                                <div className="TISComponentDownRightElementLeft"><img alt='alt' src={TISComponentClock} width={'16px'}/>
                                <div className="TISComponentDownRightElementText01"> {Math.trunc(now.getTime()/1000 - updateLastInvestmentsState[1].Date)} <TextSource ArrIndex= 'TISComponent0045'>секунды назад</TextSource></div></div>
                                <div className="TISComponentDownRightElementText02">{(props.PrerenderTexts ? JSON.parse(props.PrerenderTexts['TISComponent0050'])[props.lang] : '*проинвестировали') + ' ' + updateLastInvestmentsState[1].Amount + '$ ' + (props.PrerenderTexts ? JSON.parse(props.PrerenderTexts['TISComponent0055'])[props.lang] : '*в')+ ' '} <ChangeLink lang = {props.lang} to='/invest/monitoring'>{updateLastInvestmentsState[1].NickName}</ChangeLink></div>
                                <div className="TISComponentDownRightElementText03"> </div>
                            </div>
                        </div>
                        : <img alt='alt' src={TISDownloads} width={'24px'}/>}
                </div>
            </div>
        )}

export default TISComponent
